export default "__VITE_ASSET__7a880f21__"